import React from 'react';
import { Globe } from 'lucide-react';
import { US_TIMEZONE_OPTIONS } from '@voley/shared-utils';

interface TimezoneSectionProps {
  timezone: string;
  themePrimary: string;
  fieldErrors?: Record<string, string>;
  onTimezoneChange: (v: string) => void;
}

export function TimezoneSection({
  timezone,
  themePrimary,
  fieldErrors,
  onTimezoneChange,
}: TimezoneSectionProps) {
  return (
    <div className="bg-card-background rounded-lg border border-border p-6">
      <div className="flex items-center mb-6">
        <Globe className="h-5 w-5 text-text-secondary mr-2" />
        <h2 className="text-lg font-medium text-text-primary">Timezone</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="timezone" className="block text-sm font-medium text-text-primary mb-2">
            Organization Timezone
          </label>
          <div className="relative">
            <select
              id="timezone"
              value={timezone}
              onChange={(e) => onTimezoneChange(e.target.value)}
              className={`input appearance-none pr-10 cursor-pointer ${fieldErrors?.timezone ? 'border-red-500' : ''}`}
              style={{ '--tw-ring-color': themePrimary } as React.CSSProperties}
            >
              {US_TIMEZONE_OPTIONS.map((tz) => (
                <option key={tz.value} value={tz.value}>
                  {tz.label}
                </option>
              ))}
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <svg className="h-4 w-4 text-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
          {fieldErrors?.timezone && <p className="mt-1 text-xs text-red-500">{fieldErrors.timezone}</p>}
          <p className="mt-2 text-xs text-text-secondary">
            Used for timestamps, business hours, and scheduled messages.
          </p>
        </div>
      </div>
    </div>
  );
}
